import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Placeholder, Row, Col } from '@thd-olt-component-react/core-ui';

import styles from './project-shopping.module.scss';

const ProjectShoppingPlaceholder = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <Row>
      <Col>
        {new Array(4).fill('').map((value, key) => (
          <Placeholder
            key={`text-${key}`}
            type="text"
            className={styles.project_shopping_placeholder}
          />
        ))}
      </Col>
      <Col>
        {new Array(2).fill('').map((value, key) => (
          <Placeholder
            key={`text-${key}`}
            type="rect"
            className={styles.project_shopping_placeholder__large}
          />
        ))}
      </Col>
    </Row>
  );
};

export { ProjectShoppingPlaceholder };
